import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { Error404Component } from './error404/error404.component';
import { Error500Component } from './error500/error500.component';
import { LockComponent } from './lock/lock.component';
import { LoginComponent } from './login/login.component';
import { MfaSetupComponent } from './mfa/mfa-setup/mfa-setup.component';
import { MfaAuthorizeComponent } from './mfa/mfa-authorize/mfa-authorize.component';
import { RecoverComponent } from './recover/recover.component';
import { StyleStandardsComponent } from './style-standards/style-standards.component'

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'recover', component: RecoverComponent },
  { path: 'lock', component: LockComponent },
  { path: '404', component: Error404Component },
  { path: '500', component: Error500Component },
  { path: 'standards', component: StyleStandardsComponent }
];

@NgModule({
  imports: [CommonModule,
    RouterModule.forRoot(routes),
    SharedModule
  ],
  declarations: [LockComponent,
    RecoverComponent,
    Error404Component,
    Error500Component,
    LoginComponent,
    MfaSetupComponent,
    MfaAuthorizeComponent,
    StyleStandardsComponent
  ],
  exports: [LockComponent,
    RecoverComponent,
    Error404Component,
    Error500Component,
    LoginComponent,
    MfaSetupComponent,
    MfaAuthorizeComponent,
    StyleStandardsComponent
  ]
})
export class PagesModule {}
